module.exports = __webpack_public_path__ + "static/media/Castlewood-Master-Deed.50a5fe8a.pdf";